import { render } from "./pegawai.vue?vue&type=template&id=170a4a37"
import script from "./pegawai.vue?vue&type=script&lang=js"
export * from "./pegawai.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__